module.exports = {
    blob: {
        scale: {
            x: '3%',
        },
        texture: '/img/flux/circle-B-01.png',
    },

    // emotionC: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/content.png',
    // },
    //
    // emotionT: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/taquin.png',
    // },
    //
    // emotionE: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/etonne.png',
    // },
    //
    // emotionL: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/eloquent.png',
    // },
    //
    // emotionF: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/fier.png',
    // },
    //
    // emotionP: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/complice.png',
    // },
    //
    // emotionD: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/decourage.png',
    // },
    //
    // emotionA: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/fache.png',
    // },
    //
    // emotionN: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/normal-2.png',
    // },
    //
    // emotionG: {
    //     scale: {
    //         x: '100%',
    //     },
    //     texture: '/img/leon/normal-2.png',
    // },
};



// WEBPACK FOOTER //
// ./js/objects/partials/blob.js